<template>
  <span role="img" :title="$gettext('height_diff_up')" :aria-label="$gettext('height_diff_up')"
    ><fa-icon icon="arrow-right" :transform="{ rotate: -45 }"
  /></span>
</template>
